import { useContext } from "react";
import { QuestionnaireContext } from "@Totum/QuestionnaireBuilder/State/provider";
import { IQuestionnaireDetails } from "@Totum/QuestionnaireBuilder/Domain/types";

export const useCurrentQuestionnaireDetails = (): [
    IQuestionnaireDetails | undefined,
    (details?: IQuestionnaireDetails | undefined) => void
] => {
    const { currentQuestionnaireDetails, setCurrentQuestionnaireDetails } = useContext(QuestionnaireContext);

    return [
        // The current questionnaire details
        currentQuestionnaireDetails,
        // The function to set the current questionnaire details
        setCurrentQuestionnaireDetails,
    ];
};
